import type { RootState } from '@/store/store'
import { selectActiveContentViewerSession } from '@/content-viewer/store/selectors'
import { useAppSelector } from '@/store/store-hooks'
import { selectChatPanelOpen, selectChatPanelTab } from '../store/selectors'
import { ChatPanelTabType } from '../store/slice'
import { useDraftWorkspace } from './useDraftWorkspace'
import { useSourceOpensInChatPanel } from './useSourceOpensInChatPanel'

/**
 * The chat side panel's tabs: the source open beside the conversation, if any, and which of the two
 * the panel is on. The tab bar and what each tab shows read the same source here, so they cannot
 * disagree about whether there is one.
 */
export function useChatPanelTabs() {
  const { draftArtifactVersionId } = useDraftWorkspace()
  const sourceOpensInChatPanel = useSourceOpensInChatPanel()
  const session = useAppSelector(selectActiveContentViewerSession)
  const selectedTab = useAppSelector((state: RootState) =>
    draftArtifactVersionId ? selectChatPanelTab(state, { draftArtifactVersionId }) : ChatPanelTabType.Assistant
  )
  const panelOpen = useAppSelector((state: RootState) => (draftArtifactVersionId ? selectChatPanelOpen(state, { draftArtifactVersionId }) : false))

  const sourceSession = sourceOpensInChatPanel ? session : null

  return {
    sourceSession,
    hasSourceTab: sourceSession !== null,
    selectedTab,
    /** Whether the panel is open and showing the source, rather than collapsed or on the conversation tab. */
    sourceVisible: sourceSession !== null && panelOpen && selectedTab === ChatPanelTabType.Source,
  }
}
